/**
 * GSTR9New DataUpload Reducer
 */

import produce from 'immer';
import {
  SET_UPLOAD_PROGRESS,
  SET_UPLOAD_STATUS,
  SET_SELECTED_FILE,
  CLEAR_SELECTED_FILE,
  SET_UPLOAD_HISTORY,
} from './constants';

// Import common constants
import {
  LOADER_STATUS,
} from '../common/constants';

// The initial state of the DataUpload
export const initialState = {
  loaderStatus: false,
  selectedFile: null,
  uploadProgress: 0,
  uploadStatus: '',
  uploadHistory: [],
};

/* eslint-disable default-case, no-param-reassign */
const dataUploadReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case LOADER_STATUS:
        draft.loaderStatus = action.loaderStatus;
        break;
      
      case SET_SELECTED_FILE:
        draft.selectedFile = action.selectedFile;
        break;
      
      case CLEAR_SELECTED_FILE:
        draft.selectedFile = null;
        break;
      
      case SET_UPLOAD_PROGRESS:
        draft.uploadProgress = action.uploadProgress;
        break;
      
      case SET_UPLOAD_STATUS:
        draft.uploadStatus = action.uploadStatus;
        break;
      
      case SET_UPLOAD_HISTORY:
        draft.uploadHistory = action.uploadHistory;
        break;
    }
  });

export default dataUploadReducer;
